import { render, staticRenderFns } from "./BancoAfiliacion.vue?vue&type=template&id=2d964d72&scoped=true"
import script from "./BancoAfiliacion.vue?vue&type=script&lang=js"
export * from "./BancoAfiliacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d964d72",
  null
  
)

export default component.exports